import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable, of, tap } from 'rxjs';
import { AuthResponse, AuthServiceInterface } from '../../interfaces/auth.service.interface';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthService implements AuthServiceInterface {
    baseUrl = environment.apiUrl;

    constructor(
        private localStorageService: LocalStorageService,
        private http: HttpClient,
        private router: Router
    ) {}

    getAuthToken() {
        return this.localStorageService.getItem('token');
    }

    isAuthenticated() {
        return this.localStorageService.getItem('token') !== null;
    }

    authenticate(accessToken: string | null): Observable<AuthResponse> {
        return this.http.get<AuthResponse>(`${this.baseUrl}/auth/access/${accessToken}`).pipe(
            tap((response) => {
                if (response.token) {
                    this.localStorageService.setItem('token', response.token);
                }
            })
        );
    }

    refreshToken() {
        return this.http.get<AuthResponse>(`${this.baseUrl}/token/refresh`, { responseType: 'json' }).pipe(
            tap((response) => {
                if (response.token) {
                    this.localStorageService.setItem('token', response.token);
                }
            })
        );
    }

    logout() {
        this.localStorageService.removeItem('token');
        this.router.navigate(['/not-authorized']);
    }
}
